const dopuszczalnaMasaCalkowita = {
    t: 'Dopuszczalna masa całkowita',
    name: 'dopuszczalna-masa',
    type: 'number',
    unit: 'kg'
}

export default dopuszczalnaMasaCalkowita